<template lang="html">
  <div class="companies">
    <div class="companies-cover">
      <video autoplay muted loop playsinline poster="/static/video/companies.jpg">
        <source src="/static/video/companies.mp4" type="video/mp4"/>
      </video>
    </div>
    <div class="companies-content">
      <p>Ниже приведен список фабрик, с&nbsp;которыми мы&nbsp;работаем. Если нужной фабрики нет в&nbsp;списке, <router-link to="/contact">отправьте</router-link> нам запрос: скорее всего мы&nbsp;сможем ее&nbsp;привести специально для вас.</p>
      <div class="companies-search">
        <input autocapitalize="off" autocomplete="off" autocorrect="off" type="text" v-model="input" placeholder="Искать по фабрикам">
      </div>
      <div class="companies-list">
        <div v-for="company in filteredCompanies" class="companies-listItem">
          <a :href="company.link" target="_blank">{{ company.title }}</a>
        </div>
      </div>
      <div v-if="filteredCompanies.length == 0" class="companies-notFound">
        Такой фабрики нет в списке. Но скорее всего мы&nbsp;сможем ее&nbsp;привести — <router-link to="/contact">пишите</router-link>.
      </div>
    </div>
  </div>
</template>

<script>
import Fuse from 'fuse.js'
import _ from 'underscore'
import translit from 'cyrillic-to-translit-js'

import listOfCompanies from '../assets/companies'

const options = {
  shouldSort: true,
  threshold: 0.5,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: [
    "title",
    "author.firstName"
  ]
};

export default {

  created () {
    this.fuse = new Fuse(this.companies, options);
  },

  computed: {
    filteredCompanies: function () {
      if (this.input.trim().length == 0) return this.companies
      return this.fuse.search(translit().transform(this.input))
    }
  },
  data: function () {
    return {
      input: '',
      companies: listOfCompanies
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../scss/settings';
@import '../scss/mixins';

.companies {
  padding-top: 100px;
  @include stickyFooter();
  @include container();
}

.companies-content {
  padding: 16px $padding;
}

.companies-cover {
  padding-bottom: 100%;
  position: relative;
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.companies-map {
  opacity: 0.4;
}

.companies-list {
  margin-top: 30px;
}

.companies-listItem {
  margin-bottom: 8px;
}

.companies-letter {
  @extend .companies-listItem;
  opacity: 0.4;
  margin-top: 16px;
}

.companies-search {
  margin-top: 40px;
}

.companies-search input {
  width: 100%;
  border: none;
  border-bottom: 1px solid #000;
  outline: none;
  line-height: 2em;
  border-radius: 0;
  padding-left: 0;
  &::placeholder {
    color: rgba(#000, 0.2);
  }

}

.companies-notFound {
  margin-top: 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/Companies.vue